export default "__VITE_ASSET__Dqvo5siD__"